

export default function initInputNumbers() {

  const eventNumber = new Event("change-value");

  document.querySelectorAll('.input-number').forEach(function(holder) {
    const input = holder.querySelector('input[type="number"]');
    const btnPlus = holder.querySelector('.btn-plus');
    const btnMinus = holder.querySelector('.btn-minus');
    let currentVal = parseFloat(input.value);
    const step = input.getAttribute('step') ? parseFloat(input.getAttribute('step')) : 1;
    const max = input.getAttribute('max') ? parseFloat(input.getAttribute('max')) : Infinity;
    const min = input.getAttribute('min') ? parseFloat(input.getAttribute('min')) : -Infinity;

    
    function increase() {
      currentVal += step;
      if(currentVal > max) {
        currentVal = max;
      }
    }
    function decrease() {
      currentVal -= step;
      if(currentVal < min) {
        currentVal = min;
      }
    }

    btnPlus.addEventListener('click', function(e){
      e.preventDefault();
      increase();
      input.value = currentVal;
      input.dispatchEvent(eventNumber);

    })
    btnMinus.addEventListener('click', function(e){
      e.preventDefault();
      decrease();
      input.value = currentVal;
      input.dispatchEvent(eventNumber);
    })
  });
}